import { render, staticRenderFns } from "./RivalSubMenu.vue?vue&type=template&id=3c95d908&scoped=true&"
import script from "./RivalSubMenu.vue?vue&type=script&lang=js&"
export * from "./RivalSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./RivalSubMenu.vue?vue&type=style&index=0&id=3c95d908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c95d908",
  null
  
)

component.options.__file = "RivalSubMenu.vue"
export default component.exports